import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useStore } from "../store";
import StripeModal from "./StripePaymentModal";



var React = require("react");
var useEffect = React.useEffect;
var Modal = require("bootstrap").Modal;
var i18n = require("../i18n").default;


 function CreditModal(props:any) {
  var isOpen = props.isOpen;
  var onClose = props.onClose;
  const { auth, setAuth } = useStore();

  const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY as string)



  useEffect(() => {
      if (!isOpen) return;

  }, [])


  return (

      <Elements stripe={stripePromise}>
        <StripeModal isOpen={isOpen} onClose={onClose} />
      </Elements>
  
  );
}

export default CreditModal;
